<template>
  <div class="error-overview">
    <p>
      <span class="name">{{ error.name }}</span>
      <i
        v-if="error.detail"
        :class="['el-icon-arrow-down', showDetail ? 'active' : '']"
        @click="$emit('toggleShowDetail')"
      />
    </p>
    <p>
      <span :class="['count', error.count > 0 ? 'active' : '']">
        {{ error.count }} 句
      </span>
      <el-button
        type="text"
        :disabled="error.count === 0"
        @click="$emit('viewClick')"
      >
        {{ isDetail ? '仅查看此项' : '查看' }}
      </el-button>
    </p>
  </div>
</template>

<script>
export default {
  name: 'ErrorItem',
  props: ['error', 'isDetail'],
};
</script>
